// extracted by mini-css-extract-plugin
export default {"infoIcon":"InfoIcon_infoIcon__Mvuqz","header":"InfoIcon_header__JvXUW"};